exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-box[data-v-0cfea93e]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-between[data-v-0cfea93e]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.item-align-center[data-v-0cfea93e]{justify-items:center}.mb10[data-v-0cfea93e]{margin-bottom:10px}", ""]);

// exports
